

import styled from 'styled-components'

export const H1 = styled.h1 `
  color: white;
  text-align: center;
`

export const H2 = styled.h2 `
  color: white;
  text-align: center;
`

export const Div = styled.div `
  height: 100vh;
  width: 100%;
  margin-top: 7em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const P = styled.div `
  color: white;
  width: 50%;
  text-align: center;
`
export const RecentTechDiv = styled.div `
  margin-top: 2em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const Ul = styled.ul `
  text-align: center;
  padding: 0;
`

export const Li = styled.div `
  color: white;
  margin-top: 1em;
`

export const Link = styled.a`
  color: #ADD8E6;
`
